module.exports = __webpack_public_path__ + "media/images/signature-white-90f545701aa03f21eff0387e49bce453.png";